module.exports = __webpack_public_path__ + "img/grass.631d4fdb.png";